import React from 'react'
import PropTypes from 'prop-types'
import sanitize from 'sanitize'

function HeaderSearchResults({ hits }) {
  return (
    <ul className="c-header__search-results">
      {hits.map(hit => {
        return (
          <li key={hit.id} className="c-header__search-result">
            <a
              href={'/blog/' + hit.slug + '/'}
              className="c-header__search-result-link"
              dangerouslySetInnerHTML={{
                __html: sanitize(hit.title.rendered, {}),
              }}
            />
            <div
              dangerouslySetInnerHTML={{
                __html: sanitize(hit.excerpt.rendered, {}),
              }}
            />
          </li>
        )
      })}
    </ul>
  )
}

HeaderSearchResults.propTypes = {
  hits: PropTypes.array,
}

export default HeaderSearchResults
